import React from 'react'
import styled from 'styled-components'

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 0 auto;
  &::after {
    content: "";
    flex: 0 0 32%;
  }
`;

const CardList = (props) => {
  return (
    <List>
      {props.children}
    </List>
  )
}

export default CardList



// WEBPACK FOOTER //
// ./src/components/CardList.js